import React, { useState } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import * as S from './style'
import filterIcon from '../../../assets/stock/TableMovementHeader/filter.svg'
import { OptionsButton, SubHeaderContainer, LeftSide, RightSide, ButtonCreate } from '../../../components/styles/subheader-style'
import { Plus } from 'lucide-react'
import { RefreshIcon, RefreshIconContainer } from '../../../components/styles/subheader-style'
import refresh_act from '../../../assets/refresh-active.svg'

export interface CollectionsOutletType {
  refresh: number
  search: string
  Styled: typeof S
  isLoading?: boolean
  setIsLoading?: React.Dispatch<React.SetStateAction<boolean>>
}

const Collections: React.FC = () => {
  const location = useLocation()
  const [search, setSearch] = useState<string>('')
  const [refresh, setRefresh] = useState<number>(0)
  const [isLoading, setIsLoading] = useState<boolean>(false)

  const handleNewCollection = () => {
    window.location.href = '/panel/collections/register'
  }

  const outletContext: CollectionsOutletType = {
    refresh,
    search,
    Styled: S,
    isLoading,
    setIsLoading,
  }


  const isRegisterOrEdit =
    location.pathname.includes('/register') ||
    location.pathname.includes('/edit')

  if (isRegisterOrEdit) {
    return <Outlet context={outletContext} />
  }

  return (
    <>
      <SubHeaderContainer>
        <LeftSide>
          <S.Title>Coleções</S.Title>
        </LeftSide>
        <RightSide>
          <RefreshIconContainer onClick={() => setRefresh(prev => prev + 1)} title="Atualizar">
            <RefreshIcon src={refresh_act} alt="Atualizar" $spinning={isLoading} />
          </RefreshIconContainer>
          <OptionsButton>
            <img src={filterIcon} alt='Filtrar' style={{ width: '1.5rem', height: '1.5rem' }} />
          </OptionsButton>
          <ButtonCreate onClick={handleNewCollection}>
            <Plus size={18} />
            Nova coleção
          </ButtonCreate>
        </RightSide>
      </SubHeaderContainer>

      <S.Content>
        <Outlet context={outletContext} />
      </S.Content>
    </>
  )
}

export default Collections
